import React, { useCallback, useRef, useState} from 'react';
import { useHistory } from "react-router-dom";
import Popup from 'popup/Popup';
import { customAxiosPostFunction, customAxiosGetFunction } from 'utils/axiosFunction';
import { PasswordPopupContainer } from './DeleteEventLog.css';

import {useSelector} from 'react-redux';
import { SHA256 } from 'utils/SHA256';

const DeleteEventLog = ({ setData, warningLogIdxs }) => {   
  const userIdx = useSelector((store) => store.loginManager.status.userIdx);
  const userLevel = useSelector((store) => store.loginManager.status.authLevel);
  const history = useHistory();
  const [ popupOpen, setPopupOpen ] = useState(false);
  const inputEl = useRef(null);

  // 비밀번호 입력 후 현재 계정의 비밀번호와 일치하는지 확인. 일치 시 이벤트 로그 삭제 허용.
  const deleteEventLogFunction = useCallback(async () => {
    const password = await inputEl.current.value;
    customAxiosPostFunction(history, '/api/user/isValidPw', {'userIdx': userIdx, 'userPw': SHA256(password)})    
      .then(response => {
        if(response === false){
          alert('비밀번호가 일치하지 않습니다.');
          setPopupOpen(false);
          return false;
        }else if(window.confirm("현재 페이지의 이벤트 이력이 삭제됩니다. 계속하시겠습니까?")){
          customAxiosPostFunction(history, '/api/log/delete', {logIdxs: warningLogIdxs})
            .then(response => {
              if(response !== 0) {
                alert('삭제가 완료되었습니다.')
                setData([]);
                setPopupOpen(false);
              }
            })
            .catch(function (error) {
              console.log(error);
            });
        }else { // confirm창 취소 눌렀을 때.
          setPopupOpen(false);
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }, [warningLogIdxs]);

  if(userLevel > 2){
    return (
      <div className="search-condition col-xl-3 col-sm-6">
          <button className="table-search-submit btn btn-info" onClick={() => alert("안전관리자 이상 권한만 초기화 가능합니다.")}>이벤트 로그 초기화</button>
        </div>
    )
  }

  return (
    <Popup
      trigger={
        <div className="search-condition col-xl-3 col-sm-6">
          <button className="table-search-submit btn btn-info">이벤트 로그 초기화</button>
        </div>
      }
      modal
      closeOnDocumentClick
      open={popupOpen}
      onOpen={() => { setPopupOpen(true); }}
      >
        <PasswordPopupContainer>
          <div>
            비밀번호 : <input type="password" ref={inputEl} />
          </div>
          <div>
            <button className="btn btn-primary" onClick={() => { deleteEventLogFunction(); }}>초기화</button>
          </div>
        </PasswordPopupContainer>
      </Popup>
  )
}

export default React.memo(DeleteEventLog);